import React from 'react';
import { Container, Typography, Link, Divider, List, ListItem } from '@mui/material';

const LAST_UPDATED = '30 Ağustos 2025';
const CONTACT_EMAIL = 'info@suzmesayac.com'; // gerekirse değiştir

export default function PrivacyPolicy() {
  return (
    <Container component="main" maxWidth="md" sx={{ py: 4 }}>
      <Typography component="h1" variant="h4" gutterBottom>Gizlilik Politikası</Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Son güncelleme: {LAST_UPDATED}
      </Typography>

      <Typography paragraph>
        Bu politika, Süzme Sayaç’ın web ve mobil uygulamalarında kişisel verilerinizi nasıl işlediğimizi açıklar.
        Uygulamayı kullanarak bu politikayı kabul etmiş olursunuz.
      </Typography>

      <Divider sx={{ my: 2 }} />

      <Typography variant="h6" gutterBottom>Topladığımız Veriler</Typography>
      <List dense>
        <ListItem disableGutters>• Hesap bilgileri: e-posta, ad/soyad (opsiyonel)</ListItem>
        <ListItem disableGutters>• Kullanım verileri: uygulama içi etkileşim olayları (performans/analitik)</ListItem>
        <ListItem disableGutters>• Cihaz bilgileri: işletim sistemi, uygulama sürümü; (mobil) reklam kimliği</ListItem>
        <ListItem disableGutters>• Günlük (log) verileri ve hata raporları</ListItem>
        <ListItem disableGutters>• (Web) Çerezler ve benzeri yerel depolama</ListItem>
      </List>

      <Typography variant="h6" gutterBottom>Veri İşleme Amaçları</Typography>
      <List dense>
        <ListItem disableGutters>• Hizmeti sağlamak ve kimlik doğrulamak</ListItem>
        <ListItem disableGutters>• Performans ölçümü ve hata ayıklama</ListItem>
        <ListItem disableGutters>• (Mobil) reklam gösterimi ve sıklık sınırlandırma</ListItem>
        <ListItem disableGutters>• Yasal yükümlülüklere uyum</ListItem>
      </List>

      <Typography variant="h6" gutterBottom>Üçüncü Taraflar</Typography>
      <Typography paragraph>
        Analitik ve hata raporlama için Google Firebase (Analytics/Crashlytics), reklâm için Google AdMob
        SDK’ları kullanılabilir (özellikle mobil sürümlerde). Bu sağlayıcılar kendi gizlilik politikalarına tabidir.
      </Typography>

      <Typography variant="h6" gutterBottom>Veri Saklama</Typography>
      <Typography paragraph>
        Hesabınız açık kaldığı sürece ve yasal mevzuat gerektirdiği müddetçe veriler saklanır. Hesabınızı sildiğinizde
        kişisel veriler makul süre içinde anonimleştirilir veya silinir.
      </Typography>

      <Typography variant="h6" gutterBottom>Kullanıcı Hakları</Typography>
      <List dense>
        <ListItem disableGutters>• Verilerinize erişme ve düzeltme</ListItem>
        <ListItem disableGutters>• İşlemeye itiraz/kişisel verilerin silinmesini talep etme</ListItem>
        <ListItem disableGutters>• Veri taşınabilirliği (uygulanabildiği ölçüde)</ListItem>
      </List>

      <Typography variant="h6" gutterBottom>Hesap & Veri Silme</Typography>
      <Typography paragraph>
        Hesap silme özelliği uygulama içinde mevcuttur. Silme işlemini başlattığınızda ilişkili kişisel verileriniz
        mevzuata uygun şekilde silinir veya anonimleştirilir.
      </Typography>

      <Typography variant="h6" gutterBottom>İletişim</Typography>
      <Typography paragraph>
        Sorularınız için <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link> adresinden bize ulaşabilirsiniz.
      </Typography>
    </Container>
  );
}
